import styled, { css } from 'styled-components';
import Button from 'gatsby-theme-core/src/components/button/styled-button';
import Hamburger from './hamburger';

export default styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.grayColor};

  &:not(:empty):not(:first-child) {
    margin-left: 1rem;
  }
  &:not(:empty):not(:first-child):not(:has(.button-cta) + &:has(.button-cta)) {
    padding-left: 1rem;
    border-left: 1px solid #c3c9d5;
  }

  ${Button}.button-non-cta:not(${Hamburger}) {
    &:not(:hover) {
      color: ${({ theme }) => theme.fontColor};
    }
    svg {
      color: ${({ theme }) => theme.primaryColor};
      width: 1.438rem;
      height: 1.438rem;
    }
  }

  ${Button}.button-outline-dark:not(:hover) {
    border-color: #c3c9d5;
  }

  ${({ $iconOnlyUntil }) => css`
    ${Button} {
      @media all and (max-width: ${({ theme }) => theme.breakingpoints[$iconOnlyUntil]}) {
        font-size: 0;
        gap: 0;
      }
    }
  `}
`;
